import React, { useRef, useState } from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import "./dropdown.scss";
import { TrimString } from "../../../Utils/StringTrimmer";
import useDropdown from "../../../hooks/dropdown.hook";
import SearchInput from "../../search-input/search-input.component";
import { HGHighlightText } from "../../App/App";

const CompanySettingsDropdown = (props) => {
  const [IsDropdownOpen, setIsDropdownOpen] = useState(false);
  const [search, setSearch] = useState("");
  const { isOpen, refBtn, refMenu, setIsOpen } = useDropdown({ disableClickOutside: false })

  const searchInputRef = useRef(null);

  const filteredData = props?.data?.filter((val) => {
    return val[props.fieldValue]?.toLowerCase().includes(search.toLowerCase())
  })

  return (
    <Dropdown
      className={`${props?.dropStyle ? props?.dropStyle : props?.isGrayToggle ? 'custom_drop-down-gray' : 'custom_drop-down'} ${props.transparentBackgroundToggle ? "bg-transparent" : ""}    ${props.error ? "input-error" : ""}`}
      onToggle={(e) => {
        setIsDropdownOpen(e);
        setIsOpen(prev => !prev)
        setSearch("")
        if (e) {
          setTimeout(() => {
            searchInputRef.current?.focus();
          }, 100);
        }
      }}
      show={isOpen}
    >
      <Dropdown.Toggle
        ref={refBtn}
        id={props.toggleId}
        className={`company-dropdown ${props.passedClassName ? props.passedClassName : ''} ${props.selected ? "selected" : ""}   ${IsDropdownOpen ? "opened" : ""
          } ${props.disabled && props.disabledIcon ? "locked" : ""}
        
        
        
        `}
      >
        {props.children ? (
          props.children
        ) : (
          <div
            className={`selected-option d-flex ${props.disabled ? "f-darkgrey" : ""
              } ${props.toggleBtnClassName ?? ""}`}
          >
            {props?.selected ? (
              props?.showid ? (
                props?.selected[props.fieldId]
              ) : (
                TrimString(
                  props?.selected[props.fieldValue]?.replaceAll("_", " "),
                  props.trimStringSelected ?? 30
                )
              )
            ) : (
              <span className="drop-placeholder">{props?.placeholder}</span>
            )}
            {props.disabled && props.disabledIcon ? (
              <>
                {" "}
                <img
                  width={14}
                  height={14}
                  alt=""
                  src="/images/attack-surface/small-lock.svg"
                  className="ml-1"
                  style={{ marginRight: "-2rem" }}
                />
              </>
            ) : (
              <img alt="" src={props.DropImage ?? ''} className="ml-2" />
            )}
          </div>
        )}
      </Dropdown.Toggle>
      {!props.disabled && (
        <Dropdown.Menu renderOnMount
          ref={refMenu}
          className={`p-0  ${props.DropDownMenuClassName ?? ""}`}
          style={{
            zIndex: 5,
          }}
          popperConfig={props?.popperConfig}
        >
          {
            !props?.noSearch && <SearchInput
              passedRef={searchInputRef}
              className="bg-white"
              value={search}
              onChange={(value) => setSearch(value)}
            />
          }
          <div
            className="hide-scrollbar"
            style={{
              maxHeight: props?.maxHeight ?? "200px",
              overflowY: "auto",
            }}
          >
            {filteredData?.map((val) => (
              <div
                className={`dropdown_ite m mx-1 pointer d-flex contextmenu-grey-item
                
                ${!props.selectionArrowAtLeft ? "justify-content-between" : ""}
                
                ${props?.selected &&
                    props?.selected[props.fieldId] === val[props.fieldId]
                    ? "selected"
                    : ""
                  }`}
                onClick={(e) => {
                  props.onClick(
                    val[props.fieldId],
                    val[props.fieldValue],
                    e,
                    val
                  );
                  console.log('!props.controlClosing', !props.controlClosing)
                  if (!props.controlClosing) {
                    e.target.closest(".custom_drop-down").click();
                    setIsOpen(false);
                  }
                }}
                key={val[props.fieldId]}
                data-id={val[props.fieldId]}
                data-value={val[props.fieldValue]}
              >
                {props.selectionArrowAtLeft && (
                  <img
                    src={"/images/settings-v2/black-tick.svg"}
                    className="float-left tick"
                    alt=""
                    style={{
                      visibility: `${props.selected &&
                        props.selected[props.fieldId] === val[props.fieldId]
                        ? "visible"
                        : "hidden"
                        }`,

                      filter: `${props.greyTextAndArrowTheme
                        ? "invert(46%) sepia(2%) saturate(3030%) hue-rotate(187deg) brightness(84%) contrast(85%)"
                        : ""
                        }`,
                    }}
                  />
                )}
                <span
                  className={`${props.selectionArrowAtLeft ? "pl-1" : ""}
                
                ${props.greyTextAndArrowTheme ? "f-grey" : ""}
                
                `}
                >
                  {" "}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: HGHighlightText(TrimString(
                        val[props.fieldValue]?.replaceAll("_", " "),
                        props.trimStringItem ?? 54
                      ), search)
                    }}
                  />
                </span>
                {!props.selectionArrowAtLeft && (
                  <>
                    {val.isLoading ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        className="ml-2"
                      />
                    ) : props.selected &&
                      props.selected[props.fieldId] === val[props.fieldId] ? (
                      <img
                        src={"/images/msp/dropdown-grey-tick.svg"}
                        className="float-right tick"
                        alt=""
                      />
                    ) : null}
                  </>
                )}
              </div>
            ))}
          </div>
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
};

export default CompanySettingsDropdown;

export const CustomCompanySettingsDropdown = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dropdown
      className="custom_drop-down-adjustable"
      show={isOpen}
      onToggle={(e) => setIsOpen(e)}
    >
      <Dropdown.Toggle className={`${props.selected ? "selected" : ""}`}>
        <div className="selected-option">
          {props?.selected ? (
            props?.showid ? (
              props?.selected[props.fieldId]
            ) : (
              props?.showWithSlash ? (
                `/${props?.selected[props.fieldValue]?.replaceAll("_", " ")}`
              ) : (
                TrimString(
                  props?.selected[props.fieldValue]?.replaceAll("_", " "),
                  30
                )
              )
            )
          ) : (
            <span className="drop-placeholder">{props?.placeholder}</span>
          )}
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu renderOnMount>
        {props?.data?.map((val) => (
          <div
            className={`dropdown_item ${props?.selected &&
              props?.selected[props.fieldId] === val[props.fieldId]
              ? "selected"
              : ""
              }`}
            onClick={(e) => {
              props.onClick(val[props.fieldId], val[props.fieldValue], e, val);
              if (!props.controlClosing) {
                e.target.closest(".custom_drop-down-adjustable").click();
                setIsOpen(false);
              }
            }}
            key={val[props.fieldId]}
            data-id={val[props.fieldId]}
            data-value={val[props.fieldValue]}
          >
            {TrimString(val[props.fieldValue]?.replaceAll("_", " "), 54)}
            {val.isLoading ? (
              <Spinner
                animation="border"
                size="sm"
                className="float-right ml-2"
              />
            ) : props.selected &&
              props.selected[props.fieldId] === val[props.fieldId] ? (
              <img
                src={"/images/settings-v2/black-tick.svg"}
                className="float-right tick"
                alt=""
              />
            ) : null}
          </div>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};
